import React from "react";
import "./Richtext.scss";
import DOMPurify from "dompurify";

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
    if ('target' in node) {
      node.setAttribute('target', '_blank');
    }
});

const Richtext = ({ content } : { content: string} ) => {

    const clean = DOMPurify.sanitize(content);
    return <div className="rich-text-content" dangerouslySetInnerHTML={{ __html: clean }}></div>
}

export default Richtext;